import type { MinimumRestViolation } from 'modules/shift_management/lib/minimumRestBetweenDays'

export type MinimumRestTooltipContent = {
  header: string | null
  items: string[]
}

export const buildMinimumRestTooltipContent = (
  violations: MinimumRestViolation[],
  singleLine: string,
  multipleHeader: string
): MinimumRestTooltipContent => {
  if (!violations.length) return { header: null, items: [] }

  if (violations.length === 1) {
    const date = violations[0]?.violationDay.format('L')
    return { header: null, items: [`${date}: ${singleLine}`] }
  }

  return {
    header: multipleHeader,
    items: violations.map((violation) => violation.violationDay.format('L')),
  }
}
